/**
 *  Follow.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Row, Col } from "react-bootstrap";

// components
import Loading from "../Loader/Loader.jsx";
import { darkModeStyle, whiteModeStyle, icon_victim_help, icon_agressor, icon_victim } from "./Variables.jsx";

// redux
import { connect } from 'react-redux';

// Maps
import { compose, withProps } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from "react-google-maps";

// style 
import "./style.css";

// global
var firebase = require("../../firebase");
var aggressors = [];
var victims = [];

class Follow extends Component {
  
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            open: false,
            markers: null,
            iconVictim: icon_victim
        };
    }

    componentWillMount() {
        document.title = "Security Care | Acompanhar";
    }

    componentDidMount() {
        if (this.props.location.data == undefined){
            this.props.history.push('/register');
        } else {
            this.setState({ loading: true}, () => {
                this.getLocationAggressors(this.props.location.data);
            });
        }
    }

    getLocationAggressors = (data) => {
        aggressors = [];
        victims = [];
        
        firebase.database.ref(`locationUsers/${data.aggressorKey}/l`).once('value').then((aggressor) => {
            this.getLocationVictims(aggressor.val(), data);
        });
    }

    getLocationVictims = (aggressorLocation, data) => {
        firebase.database.ref(`locationUsers/${data.victimKey}/l`).once('value').then((victim) => {
            if (data.status.props.children === "Em alerta" || data.status === 1) {
                this.setState({iconVictim: icon_victim_help})
            }
            
            this.getLocation(aggressorLocation, victim.val(), data);
        });
    }

    getLocation = (aggressorLocation, victimsLocations, data) => {
        if (aggressorLocation) {
            this.showAgressors(aggressorLocation, data);
        }

        if (victimsLocations) {
            this.showVictims(victimsLocations, data);
        }

        this.getMarkers();
    }

    showAgressors = (aggressor, data) => {
        const { users } = this.props;

        for (var val in users) {
            if (users.hasOwnProperty(val)) {
                if (users[val].key === data.aggressorKey) {
                    if (aggressor !== null) {
            
                        let value = {};
                        value["lat"] = aggressor[0];
                        value["long"] = aggressor[1];
                        value["info"] = users[val];

                        aggressors.push(value);
                    }
                }
            }
        }
    }

    showVictims = (victim, data) => {
        const { users } = this.props;

        for (var val in users) {
            if (users.hasOwnProperty(val)) {
                if (users[val].key === data.victimKey) {
                    if (victim !== null) {
                        let value = {}
                        value["lat"] = victim[0];
                        value["long"] = victim[1];
                        value["info"] = users[val];

                        victims.push(value);
                    }
                }
            }
        }
    }

    getMarkers = () => {
        let markers = [];
        setTimeout(() => {
            for (var key in aggressors) {
                let aggressor = aggressors[key];
                
                markers.push(
                    <Marker position={{ lat: aggressor.lat, lng: aggressor.long }}  icon={icon_agressor}>
                        <InfoWindow>
                            <span>{aggressor.info.name}</span>
                        </InfoWindow> 
                    </Marker>)
            }

            for (var key in victims) {
                let victim = victims[key];

                markers.push(
                    <Marker position={{ lat: victim.lat, lng: victim.long }}  icon={this.state.iconVictim}> 
                        <InfoWindow>
                            <span>{victim.info.name}</span>
                        </InfoWindow> 
                    </Marker>)
            }
            this.setState({ markers }, () => {
                this.setState({loading: false, open: true});
            });
        }, 2000);
    }

    loadMarkers = () => {
        return this.state.markers;
    }

    insertCard = () => {
        let aggressor = null;
        let victim = null;

        for (var key in aggressors) {
            aggressor = aggressors[key];
            for (var key in victims) {
                victim = victims[key];
                return (
                    <div className="map-info-card">
                        <Row>
                            <Col sm={6}>
                                <div className="info-card">
                                    <p><strong>Agressor:</strong> {aggressor.info.name}</p>
                                    <p><strong>CPF:</strong>  000.000.000-00</p>
                                    <p><strong>Contato:</strong>  +55 9 9999-999</p>
                                </div>
                            </Col>
                            <Col sm={6}>
                                <div className="info-card">
                                    <p><strong>Vitima:</strong> {victim.info.name}</p>
                                    <p><strong>CPF:</strong>  000.000.000-00</p>
                                    <p><strong>Contato:</strong>  +55 9 9999-999</p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                )
            }
        }
    }

    render() {
        const { loading, open } = this.state;

        const MyMapComponent = compose(
            withProps({
                    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDtfgAc1X2E0xI3pGsVl_kjKglZsg5vwdA&v=3.exp&libraries=geometry,drawing,places",
                    loadingElement: <div style={{ height: `100%` }} />,
                    loadingElement: <div style={{ height: `100%` }} />,
                    containerElement: <div style={{ height: `100%` }} />,
                    mapElement: <div style={{ height: `100%` }} />,
                }),
                withScriptjs,
                withGoogleMap
                )((props) =>
                <GoogleMap
                    defaultZoom={13}
                    defaultCenter={{ lat:  -26.3044, lng: -48.8464 }}
                    options={{
                        styles: darkModeStyle,
                    }}
                >                                                
                    {open && this.loadMarkers()}
                </GoogleMap>
            )

        return (
            <div className="content content-a">
                { loading && <Loading /> }

                <Grid fluid>
                    {!loading && <MyMapComponent />}
                    {!loading && this.insertCard()}
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    users: store.users.users
});

export default connect (mapStateToProps)(Follow);








// WEBPACK FOOTER //
// ./src/views/Follow/Follow.jsx